/* 商品ページ: ★（商品カード・追従バー）を押すとレビューを下から出るシートで開く（2026-10-09）。
   ページ下部の Judge.me ウィジェットを開くときだけシートへ移し、閉じたら元の場所へ戻す。ページの位置は動かさない。 */
(() => {
  const sheet = document.getElementById('mce-review-sheet');
  if (!sheet || typeof sheet.showModal !== 'function') return;
  const body = sheet.querySelector('[data-mce-sheet-body]');
  const head = sheet.querySelector('[data-mce-sheet-grip]');
  let home = null, opener = null, y = 0, closing = false;
  let popupDefaults = null, popupOpener = null;
  const portals = new Map();
  const portalSelector = '.jm-mfp-bg, .jm-mfp-wrap, .jdgm-write-review-modal';
  // Judge.me の画像・写真一覧は通常 body に追加される。dialog の内側へ収める。
  const containPortals = () => {
    if (!sheet.open) return;
    document.querySelectorAll(portalSelector).forEach(node => {
      if (sheet.contains(node)) return;
      const marker = document.createComment('mce-review-popup-home');
      node.before(marker);
      portals.set(node, marker);
      sheet.append(node);
    });
  };
  const observer = new MutationObserver(containPortals);
  const configurePopup = () => {
    const defaults = window.jdgm?.$?.magnificPopup?.defaults;
    if (!defaults || popupDefaults) return;
    popupDefaults = { defaults, prependTo: defaults.prependTo,
      fixedContentPos: defaults.fixedContentPos, fixedBgPos: defaults.fixedBgPos };
    defaults.prependTo = sheet;
    defaults.fixedContentPos = true;
    defaults.fixedBgPos = true;
  };
  const dismissPopup = () => {
    const popup = window.jdgm?.$?.magnificPopup;
    if (sheet.querySelector('.jm-mfp-wrap') && popup?.instance?.isOpen) {
      popup.close();
      popupOpener?.focus({ preventScroll: true });
      return true;
    }
    const form = sheet.querySelector('.jdgm-write-review-modal');
    if (form && getComputedStyle(form).display !== 'none') {
      form.querySelector('.jdgm-write-review-modal__close-btn')?.click();
      return true;
    }
    return false;
  };
  sheet.addEventListener('click', event => {
    if (!sheet.open) return;
    configurePopup();
    const target = event.target.closest?.('.jdgm-gallery__thumbnail-link, .jdgm-rev__pic-link');
    if (target && !target.closest('.jm-mfp-wrap')) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      popupOpener = target;
    }
  }, true);
  // Escape は画像を先に閉じ、次の Escape でレビュー欄へ戻る。
  sheet.addEventListener('keydown', event => {
    if (event.key === 'Escape' && dismissPopup()) {
      event.preventDefault(); event.stopPropagation();
    }
  }, true);
  const widget = () => document.getElementById('judgeme_product_reviews');
  const open = trigger => {
    const w = widget();
    if (!w || closing) return false;
    if (sheet.open) return true;
    opener = trigger; y = scrollY;
    home = document.createComment('mce-review-home');
    w.before(home); body.append(w);
    document.documentElement.classList.add('mce-sheet-open');
    sheet.showModal(); body.scrollTop = 0;
    configurePopup();
    observer.observe(document.body, { childList: true, subtree: true });
    containPortals();
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    return true;
  };
  const close = () => {
    if (!sheet.open || closing) return;
    closing = true;
    dismissPopup();
    sheet.classList.remove('is-open');
    setTimeout(() => sheet.close(), matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
  };
  sheet.addEventListener('close', () => {
    observer.disconnect();
    dismissPopup();
    portals.forEach((marker, node) => {
      // 閉じて detach 済みのビューアーは復活させない。
      if (sheet.contains(node) && marker.isConnected) marker.replaceWith(node);
      else marker.remove();
    });
    portals.clear();
    if (popupDefaults) {
      const { defaults, prependTo, fixedContentPos, fixedBgPos } = popupDefaults;
      Object.assign(defaults, { prependTo, fixedContentPos, fixedBgPos });
      popupDefaults = null;
    }
    popupOpener = null; closing = false;
    const w = body.querySelector('#judgeme_product_reviews');
    if (w && home) home.replaceWith(w);
    home = null;
    document.documentElement.classList.remove('mce-sheet-open');
    scrollTo(0, y);
    opener?.focus({ preventScroll: true });
  });
  sheet.addEventListener('cancel', e => { e.preventDefault(); if (!dismissPopup()) close(); });
  sheet.querySelector('[data-mce-sheet-close]').addEventListener('click', close);
  sheet.addEventListener('click', e => { if (e.target === sheet) close(); });
  // 見出しを下へ引いたら閉じる
  let startY = null;
  head.addEventListener('touchstart', e => { startY = e.touches[0].clientY; }, { passive: true });
  head.addEventListener('touchmove', e => { if (startY === null) return; const d = Math.max(0, e.touches[0].clientY - startY); sheet.style.transform = `translateY(${d}px)`; }, { passive: true });
  head.addEventListener('touchend', e => { if (startY === null) return; const d = e.changedTouches[0].clientY - startY; startY = null; sheet.style.transform = ''; if (d > 80) close(); });
  // 既存の「★を押すと一番下へスクロール」より先に受け取る（capture）
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-mce-buy-rating], [data-mce-review-open]');
    if (!t) return;
    if (open(t)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();
